import React from "react";

function SvgIcMapPoi011(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M17 11c-1.102 0-2-.898-2-2 0-1.103.898-2 2-2 1.103 0 2 .897 2 2 0 1.102-.897 2-2 2m-7 0c-1.102 0-2-.898-2-2 0-1.103.898-2 2-2 1.103 0 2 .897 2 2 0 1.102-.897 2-2 2m9 4v10H9c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2h10zm7 1v8l-5-3v-2l5-3zM17 5c2.21 0 4 1.79 4 4s-1.79 4-4 4c-1.518 0-2.822-.855-3.5-2.1-.677 1.245-1.982 2.1-3.5 2.1-2.21 0-4-1.79-4-4s1.79-4 4-4c1.518 0 2.823.855 3.5 2.1C14.178 5.855 15.482 5 17 5z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi011;
